// src/components/MetaTagsUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Define metadata for different routes
const metaData = {
  "/client": {
    title: "KinOS | AI-Powered Holistic Health & Wellness App",
    description: "KinOS is your AI-powered companion for holistic health. Track nutrition, fitness, and mindfulness, connect with a supportive community, and unlock personalized insights to achieve balanced well-being.",
    ogTitle: "KinOS – Your AI-Powered Holistic Health Companion",
    ogDescription: "Track nutrition, mindfulness, and fitness with an AI coach. Join a community of wellness seekers and stay motivated on your journey.",
    keywords: "KinOS, AI health app, holistic health, AI coach, meal tracking, mindfulness, journaling, health community, wellness tracking, well-being",
    ogUrl: "https://usekinos.com/client"
  },
  "/": {
    title: "KinOS for Coaches | AI-Powered Platform for Health & Wellness Professionals",
    description: "Grow your coaching practice with KinOS. Our AI-powered platform helps health and wellness coaches scale their businesses, manage clients, and deliver personalized guidance.",
    ogTitle: "KinOS for Coaches – Elevate Your Wellness Practice",
    ogDescription: "Leverage AI to scale your coaching business. Manage clients, track progress, and deliver personalized guidance all in one platform.",
    keywords: "wellness coaches, health coaching platform, AI coaching tools, client management, fitness professionals, nutrition coaches, wellness business, coaching software",
    ogUrl: "https://usekinos.com/"
  },
  "/privacy-policy": {
    title: "Privacy Policy | KinOS",
    description: "Learn about how KinOS collects, uses, and protects your personal information.",
    ogTitle: "Privacy Policy | KinOS",
    ogDescription: "Learn more about how KinOS collects, uses, and protects your personal information.",
    keywords: "privacy policy, data protection, user privacy, KinOS privacy",
    ogUrl: "https://usekinos.com/privacy-policy"
  }
};

function MetaTagsUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Get metadata for current route (default to homepage if route not found)
    const currentMeta = metaData[path] || metaData["/"];
    
    // Update document title
    document.title = currentMeta.title;
    
    // Update meta tags
    const metaTags = {
      description: document.querySelector('meta[name="description"]'),
      keywords: document.querySelector('meta[name="keywords"]'),
      ogTitle: document.querySelector('meta[property="og:title"]'),
      ogDescription: document.querySelector('meta[property="og:description"]'),
      ogUrl: document.querySelector('meta[property="og:url"]'),
      twitterTitle: document.querySelector('meta[name="twitter:title"]'),
      twitterDescription: document.querySelector('meta[name="twitter:description"]')
    };
    
    // Update each meta tag if it exists
    if (metaTags.description) metaTags.description.setAttribute("content", currentMeta.description);
    if (metaTags.keywords) metaTags.keywords.setAttribute("content", currentMeta.keywords);
    if (metaTags.ogTitle) metaTags.ogTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.ogDescription) metaTags.ogDescription.setAttribute("content", currentMeta.ogDescription);
    if (metaTags.ogUrl) metaTags.ogUrl.setAttribute("content", currentMeta.ogUrl);
    if (metaTags.twitterTitle) metaTags.twitterTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.twitterDescription) metaTags.twitterDescription.setAttribute("content", currentMeta.ogDescription);
    
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
}

export default MetaTagsUpdater;